<template>
  <div class="doc-cover" :class="{ 'is-fluid': fluid }" :title="title">
    <i class="doc-cover__bar" />
    <span class="doc-cover__kicker">{{ kicker }}</span>
    <span class="doc-cover__name">{{ headline }}</span>
    <span class="doc-cover__org">中国数据资产网</span>
  </div>
</template>

<script>
export default {
  name: 'DocCover',
  props: {
    title: {
      type: String,
      default: ''
    },
    fluid: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    parsed() {
      const raw = String(this.title || '资料').replace(/\[仅展示\]/g, '').trim()
      const parts = raw.split(/[|｜]/).map((item) => item.trim()).filter(Boolean)
      if (parts.length >= 2) return { kicker: parts[0], headline: parts.slice(1).join('') }
      return { kicker: '资料', headline: raw || '未命名资料' }
    },
    kicker() {
      return this.parsed.kicker
    },
    headline() {
      return this.parsed.headline
    }
  }
}
</script>

<style scoped>
.doc-cover {
  container-type: inline-size;
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  aspect-ratio: 160 / 190;
  overflow: hidden;
  border-radius: 6px;
  background: linear-gradient(180deg, #082a78 0%, #145cb8 100%);
  color: #fff;
  box-sizing: border-box;
  padding: 10cqw 8cqw 8cqw 12cqw;
}
.doc-cover__bar {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4cqw;
  background: #f5c451;
}
.doc-cover__kicker {
  font-size: 11cqw;
  line-height: 1.3;
  color: #e8f0ff;
}
.doc-cover__name {
  margin-top: 8cqw;
  font-size: 15cqw;
  font-weight: 700;
  line-height: 1.35;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.doc-cover__org {
  margin-top: auto;
  font-size: 9cqw;
  color: #c5d7ef;
}
.doc-cover.is-fluid {
  aspect-ratio: auto;
  border-radius: inherit;
}
</style>
